import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { BiSolidEdit } from 'react-icons/bi';
import { AiOutlineDelete } from 'react-icons/ai';
import { FaChevronDown } from 'react-icons/fa6';
import { IoArrowBack, IoReload } from 'react-icons/io5';
import { RiCalendarLine } from 'react-icons/ri';
import { LuUpload } from 'react-icons/lu';
import { BsPrinter } from 'react-icons/bs';
import {
  Drawer, Spin, notification, Tooltip, DatePicker, Select,
  Popover, Popconfirm, Upload, message
} from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { ceil, findIndex, debounce, trim, isEmpty } from 'lodash';
import moment from 'moment';

import ProductImg from '../../../../../../../assets/images/newImages/nestle.svg';
import WarningInfoIcon from '../../../../../../../assets/images/newImages/info-icon.svg';
import InfoIcon from '../../../../../../../assets/images/newImages/info-icon-blue.svg';
import CSVFile from '../../../../../../../assets/icons/csv-file.svg';
import FileIcon from '../../../../../../../assets/icons/file-icon.svg';
import uploadIcon from '../../../../../../../assets/images/newImages/upload-icon.svg';
import WarningIcon from '../../../../../../../assets/icons/warning-modal-icon.svg';

import Pagination from '../../../../../../../components/pagination/index';
import AgGrid from '../../../../../../../components/ag-grid-table/index';
import SearchInput from '../../../../../../../components/uiComponent/inputs/searchinput/index';
import Modal from '../../../../../../../components/uiComponent/modal/index';
import CustomAntdModal from '../../../../../../../components/uiComponent/modal/antd-modal.js';
import Button from '../../../../../../../components/uiComponent/button/index';
import Input from '../../../../../../../components/uiComponent/inputs/input/index';
import AddSkuDrawer from '../../../../../../inventory/create-work-order/addSkuDrawer.js';
import WorkRowDetails from '../../../../../../inventory/create-work-order/workRowDetails.js';

import { ModalWrapper } from '../../../../../../purchase-order/po-warehouse-details/custom-drawer/style.js';
import { AddSkuDrawerWrapper } from '../../../../../../inventory/create-work-order/style';
import { CreateInventoryWorkOrderWrapper, BulkExpiryContentWrapper } from '../../../../../../inventory/create-work-order/style';
import InventoryWrapper from '../../../../../../inventory/style.js';

import XLSX from 'xlsx';
import productLabel from '../../../../../../../utils/print-labels/productLabel';
import { GetPresignedUrl } from '../../../../../../../slices/aws-services.js';
import { setItem } from '../../../../../../../slices/auth.js';
import { GetPackingItems, GetWarehouseShipments } from '../../../../../../../slices/post-shipment.js';

import {
  GetWorkOrderDetails,
  GetOrderItems,
  GetGatedStatus,
  UpdateShipQuantity,
  AddOrderItems,
  UpdateOrderDetails,
  DeleteOrderItem,
  updateState,
  removeDataEntry,
  setUpdatedSkuStatus,
  UpdateOrderItem,
  updateExpiryDate,
  CreateInboundPlan,
  appendErrorMessages,
  UpdatePrepCategory,
  editPrepCategory,
  ProcessBulkWorkOrderItem,
  BulkDeleteOrderItems,
  UpdatePrepOwner,
  editPrepOwner,
  updateShipQty,
  updateGridShippedQty,
  EditBulkOrderItemExpiry,
  GetRemainingSkuList,
  SyncSkuFullInfo,
} from '../../../../../../../slices/work-orders';

import { VALID_DATE } from '../../../../../../../utils/regex';

const { Option } = Select;

const PREP_CATEGORIES = [
  'ADULT', 'BABY', 'FC_PROVIDED', 'FRAGILE', 'GRANULAR', 'HANGER',
  'LIQUID', 'PERFORATED', 'SET', 'SHARP', 'SMALL', 'TEXTILE', 'UNKNOWN', 'NONE'
];

const defaultColDef = {
  resizable: true,
  sortable: false,
  filter: false,
  suppressRowClickSelection: true,
  suppressMenu: true,
  suppressMovable: true,
};

const gridOptions = {
  stopEditingWhenCellsLoseFocus: true,
  suppressClickEdit: true,
};

let gridApi = null;
let gridColumnApi;

const AddSkuToPlanDrawer = ({ open, onClose, packingMethod, shipmentType }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { workOrderId } = useParams();

  const [page, setPage] = useState({ pageSize: 100, pageNumber: 1 });
  const [filters, setFilters] = useState({ search: '' });
  const [searchValue, setSearchValue] = useState('');
  const [sortBy, setSortBy] = useState({ key: '', type: '' });
  const [isDelete, setIsDelete] = useState(false);
  const [isDeleteBulk, setIsDeleteBulk] = useState(false);
  const [addSku, setAddSku] = useState(false);
  const [rowIndex, setRowIndex] = useState(-1);
  const [rowIndexesForGatedStatus, setRowIndexesForGatedStatus] = useState([]);
  const [rowIndexesForExpiryDate, setRowIndexesForExpiryDate] = useState([]);
  const [rowIndexesForPrepCategory, setRowIndexesForPrepCategory] = useState([]);
  const [rowIndexesForPrepOwner, setRowIndexesForPrepOwner] = useState([]);
  const [uploadFile, setUploadFile] = useState({});
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [bulkExpiry, setBulkExpiry] = useState(false);
  const [isBulkExpiry, setIsBulkExpiry] = useState(false);
  const [selectedRowsCount, setSelectedRowsCount] = useState(0);
  const [bulkExpiryDate, setBulkExpiryDate] = useState('');
  const [bulkExpiryLoading, setBulkExpiryLoading] = useState(false);
  const [pendingBulkExpiryDate, setPendingBulkExpiryDate] = useState('');
  const [editWorkOrderItem, setEditWorkOrderItem] = useState({ id: '', key: '', value: '' });
  const [newValue, setNewValue] = useState('');
  const [workOrderStatus, setWorkOrderStatus] = useState('');
  const [processWorkOrderLoading, setProcessWorkOrderLoading] = useState(false);
  const [addressId, setAddressId] = useState(null);
  const [pendingOrderItems, setPendingOrderItems] = useState([]);
  const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
  const [pendingShipQuantityUpdates, setPendingShipQuantityUpdates] = useState({});
  const [isChanged, setIsChanged] = useState(false);
  const [showCloseWarning, setShowCloseWarning] = useState(false);
  const [pendingItemToDelete, setPendingItemToDelete] = useState(null);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printQty, setPrintQty] = useState(1);
  const [selectedItemForPrint, setSelectedItemForPrint] = useState(null);

  const {
    fetchingOrderItems,
    orderItems,
    orderItemsCount,
    fetchingSkuGatedStatus,
    updatingShipQuantity,
    deletingOrderItem,
    updatingOrderItem,
    creatingInboundPlan,
    updatingPrepCategory,
    bulkDeletingOrderItems,
    updatingPrepOwner,
    syncingSkuFullInfo,
    workOrderDetails: storeWorkOrderDetails,
  } = useSelector((state) => state.workOrders || {});

  const { shipmentDetails } = useSelector((state) => state.postShipment || {});
  const { inboundStatus } = shipmentDetails || {};

  useEffect(() => {
    if (!open) {
      setFilters({ search: '' });
      setSearchValue('');
      setSortBy({ key: '', type: '' });
      setIsChanged(false);
      setPendingDeleteIds([]);
      setPendingOrderItems([]);
      setPendingBulkExpiryDate('');
      setPendingShipQuantityUpdates({});
      setEditWorkOrderItem({ id: '', key: '', value: '' });
      setNewValue('');
    }
  }, [open]);

  useEffect(() => {
    if (open) {
      dispatch(GetWorkOrderDetails(workOrderId)).then(({ payload }) => {
        const { data } = payload || {};
        setWorkOrderStatus(data?.status || '');
        setAddressId(data?.address_id || null);
      });
      dispatch(GetOrderItems({ workOrderId, page, sortBy, filters }))
        .then(() => dispatch(appendErrorMessages()));
    }
  }, [open]);

  const handleGetSkuGatedStatus = ({ skuId, index, isPending }) => {
    setRowIndexesForGatedStatus(prev => [...prev, index]);
    dispatch(GetGatedStatus({ skuId, workOrderId })).then(({ payload }) => {
      if (payload?.success) {
        if (isPending) {
          setPendingOrderItems(prev => prev.map(item =>
            item.id === skuId ? { ...item, sku_status: payload?.skuStatus } : item
          ));
        } else {
          dispatch(setUpdatedSkuStatus({ field: 'orderItems', index, value: payload?.skuStatus }));
        }
      }
      setRowIndexesForGatedStatus(prev => prev.filter(i => i !== index));
    });
  };

  const isValidFutureDate = (date) => {
    const [year, month, day] = date.split('-').map(Number);
    const inputDate = new Date(Date.UTC(year, month - 1, day));
    const minValidDate = new Date();
    minValidDate.setUTCHours(0, 0, 0, 0);
    minValidDate.setDate(minValidDate.getDate() + 105);
    return inputDate >= minValidDate;
  };

  const handleBulkExpiryDate = () => {
    if (!bulkExpiryDate || bulkExpiryDate.trim() === '' || !VALID_DATE.test(bulkExpiryDate)) {
      return notification.warning({ message: 'Please enter a valid Expiry Date!', description: 'Valid Format: YYYY-MM-DD', top: 60 });
    }
    if (!isValidFutureDate(bulkExpiryDate)) {
      return notification.warning({ message: 'Expiry date must be at least 105 days in future from current date', top: 60 });
    }

    // Stage expiry for DB items locally (grid reflects it without an API call)
    dispatch(updateState({
      key: 'orderItems',
      value: orderItems.map(item => ({
        ...item,
        work_order_items_v2s: item.work_order_items_v2s?.map((wo, i) =>
          i === 0 ? { ...wo, expiry_date: bulkExpiryDate } : wo
        ),
      })),
    }));

    // Stage expiry for pending (unsaved) items
    setPendingOrderItems(prev => prev.map(item => ({ ...item, expiry_date: bulkExpiryDate })));

    // Remember the staged date so Confirm can flush it to DB
    setPendingBulkExpiryDate(bulkExpiryDate);

    setIsBulkExpiry(false);
    setBulkExpiryDate('');
    setIsChanged(true);
    notification.success({ top: 65, message: 'Success', description: 'Expiry Date Updated Successfully' });
  };

  const handleExpiryDateUpdation = ({ expiryDate, data, index }) => {
    if (data.is_pending) {
      if (!expiryDate || expiryDate.trim() === '' || !VALID_DATE.test(expiryDate)) {
        return notification.warning({ message: 'Please enter a valid Expiry Date!', description: 'Valid Format: YYYY-MM-DD', top: 60 });
      }
      if (!isValidFutureDate(expiryDate)) {
        return notification.warning({ message: 'Expiry date must be at least 105 days in future from current date', top: 60 });
      }
      setPendingOrderItems(prev => prev.map(item =>
        item.id === data.id ? { ...item, expiry_date: expiryDate } : item
      ));
      notification.success({ top: 65, message: 'Success', description: 'Expiry Date Updated Successfully' });
      return;
    }

    setRowIndexesForExpiryDate(prev => [...prev, index]);
    const { work_order_items_v2s } = data || {};
    const { expiry_date: oldExpiryDate, id: work_order_item_id } = work_order_items_v2s?.[0] || {};

    if (!expiryDate || expiryDate.trim() === '' || expiryDate === oldExpiryDate || !VALID_DATE.test(expiryDate)) {
      setRowIndexesForExpiryDate(prev => prev.filter(i => i !== index));
      return notification.warning({ message: 'Please enter a valid Expiry Date!', description: 'Valid Format: YYYY-MM-DD', top: 60 });
    }
    if (!isValidFutureDate(expiryDate)) {
      setRowIndexesForExpiryDate(prev => prev.filter(i => i !== index));
      return notification.warning({ message: 'Expiry date must be at least 105 days in future from current date', top: 60 });
    }
    dispatch(UpdateOrderItem({ work_order_item_id, data: { expiry_date: expiryDate } }))
      .then(({ payload }) => {
        if (payload?.success) {
          setIsChanged(true);
          dispatch(updateExpiryDate({ value: expiryDate, index }));
          notification.success({ top: 65, message: 'Success', description: 'Expiry Date Updated Successfully' });
        }
      })
      .finally(() => {
        setRowIndexesForExpiryDate(prev => prev.filter(i => i !== index));
      });
  };

  const handleSave = (id, key, value, oldValue, data) => {
    if (!id || !key) return;
    if (key === 'ship_quantity') {
      const parsedValue = parseInt(value, 10);
      if (isNaN(parsedValue) || parsedValue < 0 || String(value).trim() === '') {
        // We might want to keep the input open here, but for now we'll close it and reset to old value if invalid
        setEditWorkOrderItem({ id: '', key: '', value: '' });
        return notification.warning({ message: 'Please enter a valid ship quantity!', top: 60 });
      }
      if (parsedValue === parseInt(oldValue, 10)) {
        setEditWorkOrderItem({ id: '', key: '', value: '' });
        return;
      }
      const success = updateShipQuantity({ newValue: parsedValue, oldValue, data });
      if (success) {
        setEditWorkOrderItem({ id: '', key: '', value: '' });
      }
    }
  };

  const handleKeyDown = (e, data) => {
    e.stopPropagation();
    if (e.key === 'Enter') {
      const { value } = e.target || {};
      const { id, key, value: oldValue } = editWorkOrderItem || {};
      handleSave(id, key, value, oldValue, data);
    }
  };

  const updateShipQuantity = (params) => {
    const { newValue, oldValue, data } = params || {};
    const { work_order_items_v2s, id, is_pending } = data || {};

    if (!newValue || isNaN(newValue) || newValue <= 0 || String(newValue).trim() === '' || newValue === oldValue) {
      notification.warning({ message: 'Please enter a valid ship quantity!', top: 60 });
      return false;
    }

    const boxedQuantity = Number(data?.boxed_quantity || 0);
    if (newValue < boxedQuantity) {
      notification.warning({ 
        message: 'Invalid Quantity', 
        description: `Ship quantity cannot be less than the already packed quantity (${boxedQuantity}).`,
        top: 60 
      });
      return false;
    }

    const whStock = Number(data?.warehouse_stock || 0);
    if (is_pending) {
      if (newValue > whStock) {
        notification.warning({
          message: 'Invalid Quantity',
          description: `Ship quantity cannot exceed available warehouse stock (${whStock}).`,
          top: 60
        });
        return false;
      }
    } else {
      if (newValue > whStock) {
        notification.warning({
          message: 'Invalid Quantity',
          description: `Ship quantity cannot exceed available warehouse stock (${whStock}).`,
          top: 60
        });
        return false;
      }
    }

    if (is_pending) {
      setPendingOrderItems(prev => prev.map(item =>
        item.id === data.id ? { ...item, ship_quantity: newValue } : item
      ));
      return true;
    }

    // Stage the change locally — don't hit the API or update Redux until the user clicks Confirm.
    // Otherwise our DB drifts from Amazon's inbound plan if the user closes the drawer mid-edit.
    const { id: order_item_id } = work_order_items_v2s?.[0] || {};
    setPendingShipQuantityUpdates(prev => ({ ...prev, [order_item_id]: Number(newValue) }));
    setIsChanged(true);
    return true;
  };

  const handleUpdatePrepCategory = ({ sku, prepCategory, skuId, index, isPending }) => {
    setRowIndexesForPrepCategory(prev => [...prev, index]);
    dispatch(UpdatePrepCategory({ sku, prepCategory, skuId, workOrderId }))
      .then(({ payload }) => {
        if (payload?.success) {
          if (isPending) {
            setPendingOrderItems(prev => prev.map(item =>
              item.id === skuId ? { ...item, prep_category: prepCategory } : item
            ));
          } else {
            setIsChanged(true);
            dispatch(editPrepCategory({ value: prepCategory, id: skuId }));
          }
        }
        setRowIndexesForPrepCategory(prev => prev.filter(i => i !== index));
      });
  };

  const handleUpdatePrepOwner = ({ prepOwner, skuId, index, isPending }) => {
    setRowIndexesForPrepOwner(prev => [...prev, index]);
    dispatch(UpdatePrepOwner({ prepOwner, skuId }))
      .then(({ payload }) => {
        if (payload?.success) {
          if (isPending) {
            setPendingOrderItems(prev => prev.map(item =>
              item.id === skuId ? { ...item, prep_owner: prepOwner } : item
            ));
          } else {
            setIsChanged(true);
            dispatch(editPrepOwner({ value: prepOwner, id: skuId }));
          }
        }
        setRowIndexesForPrepOwner(prev => prev.filter(i => i !== index));
      });
  };

  const handlePrintLabels = async () => {
    if (syncingSkuFullInfo) return;
    if (!printQty || Number(printQty) <= 0) {
      notification.error({ message: 'Invalid Quantity', description: 'Please enter a valid number of units to print (greater than 0).', top: 60 });
      return;
    }
    const { id: skuId } = selectedItemForPrint || {};
    let updatedItem = selectedItemForPrint;
    await dispatch(SyncSkuFullInfo({ workOrderId, skuId })).then(({ payload }) => {
      if (payload?.success) updatedItem = payload.data;
    });
    const { sku, vendorasin, work_order_items_v2s, products_v2, item_name, prepinstruction } = updatedItem || {};
    const originalExpiryDate = selectedItemForPrint?.work_order_items_v2s?.[0]?.expiry_date;
    const { expiry_date = originalExpiryDate } = work_order_items_v2s?.[0] || {};
    const { username } = storeWorkOrderDetails || {};
    const title = item_name || vendorasin?.name || products_v2?.[0]?.name || sku || '---';
    const fnsku = updatedItem?.fnsku || vendorasin?.fnsku || products_v2?.[0]?.fnsku || products_v2?.[0]?.identifier_value || sku;
    const prep_instructions = prepinstruction || products_v2?.[0]?.prep_instructions || 'None';
    const bundle_quantity = products_v2?.[0]?.product_sku_mappings_v2?.bundle_quantity || 1;
    productLabel({
      fnsku, title,
      expiryDate: expiry_date ? moment(expiry_date).format('MM-DD-YYYY') : 'N/A',
      bundleQty: bundle_quantity,
      numberOfLabels: Number(printQty),
      username: username || 'Opulent',
      prepInstruction: prep_instructions,
    });
    setShowPrintModal(false);
    setPrintQty(1);
    setSelectedItemForPrint(null);
  };

  const disabledDate = (current) => {
    return current && current < moment().endOf('day').add(105, 'days');
  };

  const columnDefs = useMemo(() => [
    {
      headerName: '',
      width: 75,
      field: 'action',
      checkboxSelection: false,
      headerCheckboxSelection: false,
      cellRenderer: 'agGroupCellRenderer',
      suppressRowClickSelection: true,
      headerClass: 'parent-header',
      valueGetter: ({ data }) => data?.products_v2?.length || 0,
    },
    {
      children: [{ headerCheckboxSelection: true, width: 35, checkboxSelection: true, sortable: false }],
    },
    {
      headerName: 'Product Name',
      children: [{
        headerName: '', headerClass: 'parent-header', minWidth: 214, flex: 1,
        cellRenderer: ({ data }) => {
          const { item_name, image_url } = data || {};
          return (
            <div className='card-wrapper'>
              <img style={{ width: '50px', height: '50px', objectFit: 'contain', maxWidth: '50px' }}
                src={image_url || ProductImg} alt="product" />
              <span className='two-line-ellipsis'>{item_name || '---'}</span>
            </div>
          );
        }
      }]
    },
    {
      headerName: 'SKU/ASIN',
      children: [{
        headerName: '', headerClass: 'parent-header', minWidth: 180, flex: 1,
        cellRenderer: ({ data }) => {
          const { sku, vendorasin } = data || {};
          return (
            <Box display="flex" flexDirection="column">
              <Typography component='span' fontSize='14px' className='upc-code'>
                <Typography component='span' fontSize='14px' color="#7E8A90">SKU:</Typography> {sku || '---'}
              </Typography>
              <Typography component='span' fontSize='14px' className='upc-code'>
                <Typography component='span' fontSize='14px' color="#7E8A90">ASIN:</Typography> {vendorasin?.asin || '---'}
              </Typography>
            </Box>
          );
        }
      }]
    },
    {
      headerName: 'Amazon Stock', headerClass: 'parent-header-stock',
      children: [
        {
          headerName: 'Total', sortable: true, comparator: () => 0, filter: true,
          headerClass: 'amazon-parent-header', minWidth: 60, flex: 1, field: 'amazon_total',
          cellRenderer: ({ value }) => <div className='edit-able-data'><span>{value || 0}</span></div>
        },
        {
          headerName: 'Available', sortable: true, comparator: () => 0,
          headerClass: 'amazon-parent-header', filter: true, minWidth: 75, field: 'amazon_available', flex: 1,
          cellRenderer: ({ value }) => <div className='edit-able-data'><span>{value || 0}</span></div>
        }
      ]
    },
    {
      headerName: 'WH Stock',
      children: [{
        headerName: '', headerClass: 'parent-header', sortable: true, comparator: () => 0,
        filter: true, minWidth: 85, field: 'warehouse_stock', flex: 1,
        cellRenderer: ({ value }) => <div>{value || 0}</div>
      }]
    },
    {
      headerName: 'Bundle Qty',
      children: [{
        headerName: '', headerClass: 'parent-header', sortable: true, comparator: () => 0,
        filter: true, minWidth: 100, field: 'min_bundle_qty', flex: 1,
        cellRenderer: ({ value }) => <div>{value || 1}</div>
      }]
    },
    {
      headerName: 'Ship Quantity',
      children: [{
        headerName: '', headerClass: 'parent-header', sortable: true, comparator: () => 0,
        filter: true, minWidth: 110, flex: 1,
        field: 'work_order_items_v2s.[0].ship_quantity',
        valueGetter: ({ data }) => {
          const woiId = data?.work_order_items_v2s?.[0]?.id;
          const staged = pendingShipQuantityUpdates[woiId];
          return staged !== undefined ? staged : (data?.work_order_items_v2s?.[0]?.ship_quantity || 0);
        },
        cellRenderer: ({ data }) => {
          const { work_order_items_v2s, is_pending } = data || {};
          const orderItem = work_order_items_v2s?.[0] || {};
          const id = orderItem?.id;
          const stagedQty = pendingShipQuantityUpdates[id];
          const shipQuantity = stagedQty !== undefined ? stagedQty : (orderItem?.ship_quantity || 0);
          const showInput = editWorkOrderItem?.id === id && editWorkOrderItem?.key === 'ship_quantity';
          return (
            <div className='edit-able-data' onMouseDown={(e) => e.stopPropagation()}>
              {showInput
                ? <Input 
                    autoFocus 
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, data)}
                    onBlur={(e) => {
                      const value = e.target.value;
                      handleSave(id, 'ship_quantity', value, shipQuantity, data);
                    }} 
                  />
                : <span>{shipQuantity || 0}</span>
              }
              <BiSolidEdit 
                className={showInput ? 'increase-font' : ''}
                onMouseDown={(e) => {
                  e.stopPropagation();
                  e.preventDefault(); // Prevent blur of current input if clicking the same icon
                  if (showInput) {
                    // If already editing this one, let blur handle it or just keep it open
                  } else {
                    setEditWorkOrderItem({ id, key: 'ship_quantity', value: shipQuantity });
                    setNewValue(String(shipQuantity));
                  }
                }} 
              />
            </div>
          );
        }
      }]
    },
    {
      headerName: 'Expiry Date',
      children: [{
        headerName: '', headerClass: 'parent-header', minWidth: 180, flex: 1,
        field: 'work_order_items_v2s.[0].expiry_date',
        valueGetter: ({ data }) => data?.work_order_items_v2s?.[0]?.expiry_date || '',
        cellRenderer: ({ data, value }) => {
          const index = findIndex(orderItems, item => item.id === data?.id);
          const isExpiryLoading = rowIndexesForExpiryDate.includes(index);
          return (
            <div
              className='edit-able-data expiry-date-cell'
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
            >
              <DatePicker
                style={{ width: '100%' }}
                getCalendarContainer={() => document.body}
                popupStyle={{ zIndex: 1000000 }}
                disabled={isExpiryLoading}
                disabledDate={disabledDate}
                allowClear={false}
                value={value ? moment(value) : null}
                format='YYYY-MM-DD'
                onChange={(momentObj, dateStr) => {
                  handleExpiryDateUpdation({ expiryDate: dateStr, data, index });
                }}
              />
            </div>
          );
        }
      }]
    },
    {
      headerName: 'Gated Status',
      children: [{
        headerName: '', headerClass: 'parent-header', minWidth: 130, flex: 1, sortable: true, field: 'sku_status',
        cellRenderer: ({ data }) => {
          const { sku_status, id, is_pending } = data || {};
          const index = is_pending ? `pending_${id}` : findIndex(orderItems, item => item.id === id);
          return (
            <div className='not-gated-icon-wrapper' onMouseDown={(e) => e.stopPropagation()}>
              <span className={`bag-icon-gated ${sku_status === 'Gated' ? 'new-gated' : ''}`}>
                {rowIndexesForGatedStatus.includes(index) ? 'fetching...'
                  : sku_status?.toLowerCase() === 'non-gated' ? 'Not Gated' : sku_status || '---'}
              </span>
              <IoReload onClick={() => handleGetSkuGatedStatus({ skuId: id, index, isPending: is_pending })}
                style={rowIndexesForGatedStatus.includes(index) ? { pointerEvents: 'none' } : {}} />
            </div>
          );
        }
      }]
    },
    {
      headerName: 'Error Message',
      children: [{
        headerName: '', headerClass: 'parent-header', minWidth: 120, flex: 1, field: 'error_msg',
        cellRenderer: ({ data, value }) => {
          const { is_errored } = data?.work_order_items_v2s?.[0] || {};
          return (
            <div className='expired-data-wrapper error-msg'>
              <Tooltip placement='top' title={value || data?.prep_category_error || ''}>
                <p>{is_errored ? value || data?.prep_category_error || 'Ship Quantity Cannot be 0' : value || data?.prep_category_error || ''}</p>
              </Tooltip>
            </div>
          );
        }
      }]
    },
    {
      headerName: 'Prep Category',
      children: [{
        headerName: '', headerClass: 'parent-header', minWidth: 200, flex: 1, field: 'prep_category',
        cellRenderer: ({ data }) => {
          const { id: skuId, prep_category, error_msg, sku, prep_category_error = '', is_pending } = data || {};
          const index = is_pending ? `pending_${skuId}` : findIndex(orderItems, item => item.id === skuId);
          const regex = /prep\s*(category|owner)/i;
          const hasError = regex.test(error_msg) || regex.test(prep_category_error);
          return (
            <div className='expired-data-wrapper' onMouseDown={(e) => e.stopPropagation()}>
              <Select key="prep_category" showSearch optionFilterProp="label"
                style={{ width: '100%' }}
                getPopupContainer={() => document.body}
                dropdownStyle={{ zIndex: 1000000 }}
                disabled={!hasError || rowIndexesForPrepCategory.includes(index)}
                placeholder="Select Category" value={prep_category}
                onChange={(value) => handleUpdatePrepCategory({ sku, prepCategory: value, skuId, index, isPending: is_pending })}>
                {PREP_CATEGORIES.map(cat => <Option key={cat} value={cat} label={cat}>{cat}</Option>)}
              </Select>
            </div>
          );
        }
      }]
    },
    {
      headerName: 'Action',
      children: [{
        headerName: '', headerClass: 'parent-header', minWidth: 90, flex: 1,
        cellRenderer: ({ data }) => {
          const { work_order_items_v2s, is_pending } = data || {};
          const { id: order_item_id } = work_order_items_v2s?.[0] || {};
          const index = findIndex(orderItems, ({ work_order_items_v2s }) => work_order_items_v2s?.[0]?.id === order_item_id);
          return (
            <div className="d-flex align-items-center justify-content-center gap-2">
              <AiOutlineDelete onClick={() => {
                if (is_pending) {
                  setPendingItemToDelete(data);
                } else {
                  setRowIndex(index);
                }
                setIsDelete(true);
              }} className='delete-icon' />
              <BsPrinter
                className="cursor-pointer"
                style={{ color: '#1565d8', fontSize: '18px' }}
                onClick={() => {
                  setSelectedItemForPrint(data);
                  setPrintQty(data?.work_order_items_v2s?.[0]?.ship_quantity || 1);
                  setShowPrintModal(true);
                }}
              />
            </div>
          );
        }
      }]
    }
  ], [orderItems, rowIndexesForGatedStatus, updatingShipQuantity, rowIndexesForExpiryDate, rowIndexesForPrepCategory, workOrderStatus, editWorkOrderItem, newValue, pendingShipQuantityUpdates]);

  const handlePagination = (number, key) => {
    const value = Number(number);
    const newPage = key === 'pageSize' ? { pageNumber: 1, pageSize: value } : { ...page, pageNumber: value };
    setPage(newPage);
    setSelectedRowsCount(0);
    dispatch(GetOrderItems({ page: newPage, workOrderId, sortBy, filters }))
      .then(() => dispatch(appendErrorMessages()));
  };

  const refreshGridClick = () => {
    if (gridColumnApi) {
      gridColumnApi.applyColumnState({ defaultState: { sort: null }, applyOrder: true });
      setSortBy({ key: '', type: '' });
    }
    setSelectedRowsCount(0);
    dispatch(GetOrderItems({ page, workOrderId, filters }))
      .then(() => {
        dispatch(updateState({ key: 'invalidSkuMap', value: [] }));
        dispatch(appendErrorMessages());
      });
  };

  const handleDeleteOrderItem = () => {
    if (pendingItemToDelete) {
      setPendingOrderItems(prev => prev.filter(item => item.id !== pendingItemToDelete.id));
      setIsChanged(true);
      setIsDelete(false);
      setPendingItemToDelete(null);
      setSelectedRowsCount(0);
      return;
    }

    const item = orderItems?.[rowIndex];
    const boxedQuantity = Number(item?.boxed_quantity || 0);
    if (boxedQuantity > 0) {
      setIsDelete(false);
      return notification.warning({
        message: 'Cannot Delete',
        description: `This item has ${boxedQuantity} units already packed. Clear boxes before deleting.`,
        top: 60
      });
    }
    const orderItemId = item?.work_order_items_v2s?.[0]?.id;
    setPendingDeleteIds(prev => [...prev, orderItemId]);
    setIsChanged(true);
    setIsDelete(false);
    setSelectedRowsCount(0);
  };

  const handleBulkDeleteItems = () => {
    const selectedRows = gridApi.getSelectedRows();
    if ((!orderItems?.length && !pendingOrderItems?.length) || selectedRows.length === 0) {
      notification.error({ top: 65, message: 'Bulk Delete', description: 'Please select at least one row.' });
      return;
    }

    const packedItems = selectedRows.filter(item => !item.is_pending && Number(item.boxed_quantity || 0) > 0);
    if (packedItems.length > 0) {
      setIsDeleteBulk(false);
      return notification.warning({
        message: 'Cannot Delete',
        description: `${packedItems.length} of the selected items have already been packed. Clear boxes before deleting.`,
        top: 60
      });
    }

    const pendingIdsToRemove = selectedRows.filter(item => item.is_pending).map(item => item.id);
    const dbIdsToDelete = selectedRows.filter(item => !item.is_pending).map(({ work_order_items_v2s }) => work_order_items_v2s[0]?.id);

    if (pendingIdsToRemove.length > 0) {
      setPendingOrderItems(prev => prev.filter(item => !pendingIdsToRemove.includes(item.id)));
    }
    if (dbIdsToDelete.length > 0) {
      setPendingDeleteIds(prev => [...prev, ...dbIdsToDelete]);
    }
    setIsChanged(true);
    setIsDeleteBulk(false);
    setSelectedRowsCount(0);
  };

  const handleSearch = (value) => {
    setSearchValue(value);
    debounceSearch(value);
  };

  const debounceSearch = useCallback(debounce((value) => {
    if (trim(value) || filters.search) {
      const newFilters = { ...filters, search: value };
      setFilters(newFilters);
      setPage(p => ({ ...p, pageNumber: 1 }));
      setSelectedRowsCount(0);
      dispatch(GetOrderItems({ workOrderId, page: { ...page, pageNumber: 1 }, filters: newFilters, sortBy }))
        .then(() => dispatch(appendErrorMessages()));
    }
  }, 800), [filters, page, workOrderId, sortBy]);

  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find(s => s.sort != null);
    const newSortBy = value ? { key: value.colId, type: value.sort } : { key: '', type: '' };
    
    if (!value || ['warehouse_stock', 'amazon_total', 'amazon_available', 'reserved_qty', 'ship_quantity', 'min_bundle_qty', 'sku_status'].includes(value.colId)) {
      setSortBy(newSortBy);
      setSelectedRowsCount(0);
      dispatch(GetOrderItems({ page, workOrderId, filters, sortBy: newSortBy }))
        .then(() => dispatch(appendErrorMessages()));
    }
  };

  const onSelectionChange = () => setSelectedRowsCount(gridApi?.getSelectedRows?.()?.length || 0);

  const gridReady = (params) => {
    gridApi = params.api;
    gridColumnApi = params.columnApi;
  };

  const handleCreateInboundPlan = async (actualPlan) => {
    // Clear previous errors
    dispatch(updateState({ key: 'invalidSkuMap', value: [] }));
    dispatch(appendErrorMessages());
    setPendingOrderItems(prev => prev.map(item => ({ ...item, error_msg: '', is_errored: false })));

    // Flush staged bulk expiry to DB before touching Amazon
    if (pendingBulkExpiryDate) {
      await dispatch(EditBulkOrderItemExpiry({ work_order_id: workOrderId, data: { expiry_date: pendingBulkExpiryDate } }));
      setPendingBulkExpiryDate('');
    }

    // Flush staged ship quantity changes to DB so Amazon and our DB end up in lockstep
    const stagedShipQtyEntries = Object.entries(pendingShipQuantityUpdates);
    if (actualPlan && stagedShipQtyEntries.length > 0) {
      await Promise.all(
        stagedShipQtyEntries.map(([work_order_item_id, ship_quantity]) =>
          dispatch(UpdateShipQuantity({ work_order_item_id: Number(work_order_item_id), ship_quantity }))
        )
      );
      stagedShipQtyEntries.forEach(([work_order_item_id, ship_quantity]) => {
        const idx = findIndex(orderItems, item => item.work_order_items_v2s?.[0]?.id === Number(work_order_item_id));
        if (idx !== -1) {
          dispatch(updateGridShippedQty({ field: 'orderItems', index: idx, value: ship_quantity }));
        }
      });
      setPendingShipQuantityUpdates({});
    }

    // Commit staged deletions before touching Amazon — keeps our DB and Amazon in sync.
    // Don't clear pendingDeleteIds yet; we need the grid to keep hiding them until GetOrderItems
    // refreshes Redux, otherwise the deleted rows briefly flash back into view.
    if (actualPlan && pendingDeleteIds.length > 0) {
      if (pendingDeleteIds.length === 1) {
        await dispatch(DeleteOrderItem(pendingDeleteIds[0]));
      } else {
        await dispatch(BulkDeleteOrderItems({ orderItemIds: pendingDeleteIds }));
      }
    }

    // Collect all items for validation/creation (excluding staged deletes; staged ship qty wins over Redux)
    const allItemsForPlan = [
      ...orderItems
        .filter(item => !pendingDeleteIds.includes(item.work_order_items_v2s?.[0]?.id))
        .map(item => {
          const woiId = item.work_order_items_v2s?.[0]?.id;
          const stagedQty = pendingShipQuantityUpdates[woiId];
          return {
            msku: item.sku,
            quantity: stagedQty !== undefined ? stagedQty : (item.work_order_items_v2s?.[0]?.ship_quantity || 0),
            expiration: item.work_order_items_v2s?.[0]?.expiry_date || null,
            prepOwner: item.prep_category_error ? 'NONE' : (item.prep_owner || 'SELLER'),
            prepCategory: item.prep_category || null,
          };
        }),
      ...pendingOrderItems.map(item => ({
        msku: item.sku,
        quantity: item.ship_quantity || 0,
        expiration: item.expiry_date || null,
        prepOwner: item.prep_category_error ? 'NONE' : (item.prep_owner || 'SELLER'),
        prepCategory: item.prep_category || null,
      }))
    ];

    const { payload } = await dispatch(CreateInboundPlan({
      workOrderId,
      actualPlan,
      packingMethod,
      shipmentType,
      items: allItemsForPlan
    }));

    if (payload?.success && actualPlan) {
      setIsChanged(false);
      setPendingOrderItems([]);
    }

    const { invalidSkus, success } = payload || {};
    if (!isEmpty(invalidSkus)) {
      const invalidSkuMap = invalidSkus.reduce((acc, obj) => ({ ...acc, ...obj }), {});
      setPendingOrderItems(prev => prev.map(item => {
        const errorMessages = invalidSkuMap[item.sku];
        return {
          ...item,
          error_msg: errorMessages ? errorMessages[0] : "",
          is_errored: !!errorMessages
        };
      }));
      dispatch(GetOrderItems({ workOrderId, page: { ...page, pageNumber: 1 }, filters, sortBy }))
        .then(() => dispatch(appendErrorMessages()));
    } else if (payload?.success) {
      if (actualPlan) {
        setPendingOrderItems([]);

        // Refresh main data for Step 2 UI without page refresh
        if (packingMethod === 'pack_now') {
          dispatch(GetPackingItems({ workOrderId }));
        } else {
          dispatch(GetWarehouseShipments({ workOrderId }));
        }

        dispatch(GetOrderItems({ workOrderId, page, sortBy, filters }))
          .then(() => {
            dispatch(appendErrorMessages());
            // Now that Redux orderItems no longer contains the deleted ones, the filter is no longer needed
            setPendingDeleteIds([]);
          });
        onClose();
      } else {
        // Validation success case - refresh to show updated data if any
        dispatch(GetOrderItems({ workOrderId, page, sortBy, filters }))
          .then(() => dispatch(appendErrorMessages()));
      }
    }
  };

  const getConfirmBtnDisabled = () => {
    const visibleOrderItems = orderItems?.filter(item => !pendingDeleteIds.includes(item.work_order_items_v2s?.[0]?.id));
    const hasError = visibleOrderItems?.some(item => item.work_order_items_v2s?.some(wo => wo?.is_errored === true));
    const noChanges = !isChanged && !pendingOrderItems?.length && !pendingDeleteIds?.length;

    return !addressId || updatingShipQuantity || deletingOrderItem
      || bulkDeletingOrderItems || updatingPrepCategory || creatingInboundPlan
      || (!visibleOrderItems?.length && !pendingOrderItems?.length) || hasError || noChanges;
  };

  const handleClose = () => {
    if (isChanged || pendingOrderItems.length || pendingDeleteIds.length) {
      setShowCloseWarning(true);
    } else {
      onClose();
    }
  };

  // Bulk expiry content
  const { Dragger } = Upload;
  const uploadProps = {
    name: 'file', multiple: false, showUploadList: false, accept: ['.xlsx', '.xls', '.csv'],
    fileList: !isEmpty(uploadFile) ? [{ ...uploadFile, name: uploadFile.name, key: uploadFile.uid || uploadFile.name }] : [],
    onChange(info) {
      if (!info.fileList.length) return;
      const file = info.file;
      const ext = file?.name?.split('.').pop();
      if (!['xls', 'xlsx', 'csv'].includes(ext)) { message.error(`${file.name} upload failed.`); return; }
      setUploadFile(file);
    },
    beforeUpload: () => false,
    onRemove: () => { setUploadFile({}); return true; }
  };

  const handleExportOrderItems = (data) => {
    const rows = Array.isArray(data) ? data : [];
    if (!rows.length) {
      notification.error({ top: 65, message: 'Export Order Item(s)', description: 'No items to export.' });
      return;
    }
    const mappedData = rows.map((orderItem) => {
      const { sku, work_order_items_v2s } = orderItem || {};
      const filteredOrderItem = orderItems.find((item) => item.id === orderItem.id);
      return {
        'Sku': sku || '',
        'Expiry Date': work_order_items_v2s?.[0]?.expiry_date || '',
        'Quantity': work_order_items_v2s?.[0]?.ship_quantity || 0,
        'Error': filteredOrderItem?.error_msg || filteredOrderItem?.prep_category_error || ''
      };
    });
    const worksheet = XLSX.utils.json_to_sheet(mappedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Work Order');
    const fileName = storeWorkOrderDetails?.order_name || `Work-Order-${workOrderId}`;
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  const handleExportAll = () => {
    dispatch(GetOrderItems({ workOrderId, exportAll: true })).then(({ payload }) => {
      if (payload?.success) {
        // Merge in pending (unsaved) items so the export reflects what the user sees in the grid
        const pendingForExport = pendingOrderItems.map(item => ({
          ...item,
          work_order_items_v2s: [{
            ship_quantity: item.ship_quantity,
            expiry_date: item.expiry_date,
          }],
        }));
        handleExportOrderItems([...(payload.data || []), ...pendingForExport]);
      } else {
        notification.error({ top: 65, message: 'Export Order Item(s)', description: 'Failed to fetch items for export.' });
      }
    });
  };

  const handleFileUpload = async () => {
    setProcessWorkOrderLoading(true);
    if (!isEmpty(uploadFile)) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const parsedData = XLSX.utils.sheet_to_json(sheet);

          const items = [];
          for (const row of parsedData) {
            let sku = null;
            let quantity = null;
            let expiry = null;

            for (const key in row) {
              const cleanKey = String(key).trim().toLowerCase();
              if (['sku', 'msku', 'seller sku', 'merchant sku', 'product sku', 'item sku'].includes(cleanKey)) {
                sku = row[key];
              } else if (['quantity', 'qty', 'ship quantity', 'ship qty'].includes(cleanKey)) {
                quantity = row[key];
              } else if (['expiry date', 'expirydate', 'expiry_date', 'expiry', 'expiration date'].includes(cleanKey)) {
                expiry = row[key];
              }
            }

            if (sku) {
              let expiry_date = null;
              if (typeof expiry === 'number') {
                expiry_date = moment('1899-12-30').add(expiry, 'days').format('YYYY-MM-DD');
              } else if (expiry) {
                const parsedDate = moment(expiry, ['YYYY-MM-DD', 'MM/DD/YYYY'], true);
                if (parsedDate.isValid()) {
                  expiry_date = parsedDate.format('YYYY-MM-DD');
                }
              }
              items.push({
                sku: String(sku).trim(),
                ship_quantity: Number(quantity || 0),
                expiry_date
              });
            }
          }

          if (items.length === 0) {
            notification.warning({ message: 'No valid SKUs found in file', top: 60 });
            setProcessWorkOrderLoading(false);
            return;
          }

          const skus = items.map(item => item.sku);
          dispatch(GetRemainingSkuList({
            workOrderId,
            page: { pageNumber: 1, pageSize: 500 },
            filters: { skus },
            sortBy: { key: '', type: '' }
          })).then(({ payload }) => {
            if (payload?.success) {
              const fetchedSkus = payload?.data || [];
              const missingSkus = [];
              const pendingItemsToAdd = [];

              items.forEach(importedItem => {
                const match = fetchedSkus.find(r => r.sku === importedItem.sku);
                if (match) {
                  const whStock = Number(match.warehouse_stock || 0);
                  const shipQty = Number(importedItem.ship_quantity || 0);
                  let error_msg = '';
                  if (shipQty > whStock) {
                    error_msg = 'Ship Quantity Cannot exceed Warehouse Stock';
                  }

                  pendingItemsToAdd.push({
                    ...match,
                    sku_id: match.id,
                    is_pending: true,
                    ship_quantity: shipQty,
                    error_msg,
                    is_errored: !!error_msg,
                    work_order_items_v2s: [{ ship_quantity: shipQty, is_errored: !!error_msg }]
                  });
                }
                // Silently skip SKUs not returned by GetRemainingSkuList — they're typically already
                // in the work order, so the previous "not found in warehouse" warning was misleading.
              });

              if (pendingItemsToAdd.length > 0) {
                setPendingOrderItems(prev => {
                  const existingIds = new Set([...prev, ...(orderItems||[])].map(i => i.id || i.sku_id));
                  const newItems = pendingItemsToAdd.filter(item => !existingIds.has(item.id));
                  return [...prev, ...newItems];
                });
                setIsChanged(true);
                notification.success({ message: 'SKUs populated successfully', top: 60 });
              }
            } else {
              notification.error({ message: 'Failed to fetch SKU information', top: 60 });
            }
            setUploadFile({});
            setPopoverVisible(false);
            setProcessWorkOrderLoading(false);
          });

        } catch (error) {
          console.error(error);
          notification.error({ message: 'Error parsing file', top: 60 });
          setProcessWorkOrderLoading(false);
        }
      };
      reader.readAsBinaryString(uploadFile);
    } else {
      setProcessWorkOrderLoading(false);
    }
  };

  const bulkExpiryContent = (
    <BulkExpiryContentWrapper>
      <ul className='bulk-expiry-list'>
        <li onClick={() => { setPopoverVisible(true); setBulkExpiry(false); }}><LuUpload /> <span>Import</span></li>
        <li onClick={() => { setBulkExpiry(false); handleExportAll(); }}><img src={CSVFile} /> <span>Export</span></li>
        <li onClick={() => { setIsBulkExpiry(true); setBulkExpiry(false); }}><RiCalendarLine /> <span>Expiry</span></li>
        <li onClick={() => {
          if (!gridApi?.getSelectedRows()?.length) {
            notification.error({ top: 65, message: 'Bulk Delete', description: 'Please select at least one row.' });
            return;
          }
          setIsDeleteBulk(true); setBulkExpiry(false);
        }} className='delete'><AiOutlineDelete /> <span>Delete</span></li>
      </ul>
    </BulkExpiryContentWrapper>
  );

  const importModalContent = (
    <InventoryWrapper style={{ width: 350 }} className='pt-0'>
      <Spin tip='Loading...' spinning={processWorkOrderLoading}>
        <p className="text-primary d-flex align-items-center gap-1">
          <a href="https://opulant-storage.s3.us-east-1.amazonaws.com/work-order-sample.xlsx"
            target="_blank" rel="noopener noreferrer" className="text-primary d-flex align-items-center gap-1">
            <img src={InfoIcon} alt="info" />
            <span className="fs-12 fw-semibold">Download Sample File</span>
          </a>
        </p>
        <Dragger maxCount={1} {...uploadProps} style={{ marginTop: 16, padding: 16, borderRadius: 8 }}>
          <p className="ant-upload-drag-icon"><img src={uploadIcon} alt='upload' /></p>
          <p className="ant-upload-text text-primary fs-14 fw-semibold text-decoration-underline">Click or drag file to upload</p>
        </Dragger>
        <p className="text-grey d-flex align-items-center gap-1 mt-2">
          <img src={WarningInfoIcon} alt="warning" />
          <span className="fs-12 fw-semibold">Expiry date must be at least 105 days in future</span>
        </p>
        {!isEmpty(uploadFile) && (
          <div className="uploaded-file-container">
            <div className="uploading-content-data">
              <div className="title"><img src={FileIcon} alt="file" /><span>{uploadFile.name}</span></div>
              <AiOutlineDelete onClick={() => setUploadFile({})} style={{ cursor: 'pointer', color: 'red' }} />
            </div>
          </div>
        )}
        <div className='d-flex gap-2 justify-content-end mt-3'>
          <Button text="Cancel" className="outlined mb-0" onClick={() => { setPopoverVisible(false); setUploadFile({}); }} />
          <Button text="Save" disabled={isEmpty(uploadFile)} className="primary mb-0" onClick={handleFileUpload} />
        </div>
      </Spin>
    </InventoryWrapper>
  );

  const { pageNumber, pageSize } = page;

  return (
    <Drawer visible={open} closable={false} onClose={handleClose} width={'calc(100vw - 260px)'} destroyOnClose>
      <AddSkuDrawerWrapper style={{ paddingRight: 16 }}>
        <header style={{ marginBottom: 12 }}>
          <div onClick={handleClose} className='back-icon'>
            <IoArrowBack />
            <span>Add SKU</span>
          </div>
        </header>
        {/* Toolbar */}
        <div style={{ marginBottom: 12 }}>
          <section style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginTop: 0 }}>
            <SearchInput
              className="search work-order-search-bar"
              placeholder="Search by Title / ASIN / SKU"
              value={searchValue}
              onChange={({ target }) => handleSearch(target.value)}
            />
            <Box display="flex" gap={2} flexWrap="wrap">
              <Popover
                content={bulkExpiryContent}
                trigger="click"
                placement="bottom"
                arrowPointAtCenter
                visible={bulkExpiry}
                overlayClassName='bulk-expiry-popover'
                overlayStyle={{ zIndex: 10000 }}
                onVisibleChange={(v) => setBulkExpiry(v)}
              >
                <Popover
                  content={importModalContent}
                  trigger="click"
                  placement="bottomRight"
                  visible={popoverVisible}
                  overlayStyle={{ zIndex: 10000 }}
                >
                  <Button text="Bulk Action" className="outlined mb-0" endIcon={<FaChevronDown />} minWidth="90px" />
                </Popover>
              </Popover>

              <Button
                text="Add SKU"
                className="outlined mb-0"
                startIcon={<span className="icon-add pr-8"></span>}
                minWidth="90px"
                onClick={() => setAddSku(true)}
              />

              <Button
                text="Check Inbound Errors"
                className="primary mb-0"
                minWidth="90px"
                loading={creatingInboundPlan}
                disabled={!addressId || bulkExpiryLoading || updatingShipQuantity || deletingOrderItem
                  || bulkDeletingOrderItems || updatingPrepCategory || creatingInboundPlan || (!orderItems?.length && !pendingOrderItems?.length)}
                onClick={() => {
                  dispatch(updateState({ key: 'invalidSkuMap', value: [] }));
                  dispatch(appendErrorMessages());
                  dispatch(updateState({ key: 'actualPlan', value: false }));
                  handleCreateInboundPlan(false);
                }}
              />

              <Button
                text="Confirm"
                className="primary mb-0"
                minWidth="90px"
                style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                loading={creatingInboundPlan}
                disabled={getConfirmBtnDisabled()}
                onClick={() => {
                  dispatch(updateState({ key: 'invalidSkuMap', value: [] }));
                  dispatch(appendErrorMessages());
                  dispatch(updateState({ key: 'actualPlan', value: true }));
                  handleCreateInboundPlan(true);
                }}
              />
            </Box>
          </section>
        </div>

        {/* Grid */}
        <Spin tip='Loading...' spinning={deletingOrderItem || creatingInboundPlan || bulkDeletingOrderItems || fetchingOrderItems}>
          <AgGrid
            gridReady={gridReady}
            user_referrals={[
              ...orderItems.filter(item => !pendingDeleteIds.includes(item.work_order_items_v2s?.[0]?.id)),
              ...pendingOrderItems.map(item => ({
                ...item,
                is_pending: true,
                work_order_items_v2s: [{ 
                  id: `pending_${item.id}`, 
                  ship_quantity: item.ship_quantity,
                  expiry_date: item.expiry_date,
                  error_msg: item.error_msg,
                  is_errored: item.is_errored
                }]
              }))
            ]}
            defaultColDef={defaultColDef}
            columnDefinitions={columnDefs}
            gridOptions={gridOptions}
            rowHeight={64}
            headerHeight={36}
            height="420px"
            rowSelection="multiple"
            suppressRowClickSelection={true}
            masterDetail
            detailRowAutoHeight
            onSortChange={onSortChange}
            onSelectionChanged={onSelectionChange}
            detailCellRenderer={(props) => <WorkRowDetails {...props} />}
            className="sku-table"
            getRowId={(params) => params.data.id}
          />
          <Pagination
            total={orderItemsCount}
            totalPages={ceil(orderItemsCount / pageSize + 1)}
            pageNumber={pageNumber}
            pageLimit={pageSize}
            handleLimitChange={(e) => handlePagination(e, 'pageSize')}
            handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
            handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
            handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
            refreshGridClick={refreshGridClick}
            loading={fetchingSkuGatedStatus}
          />
        </Spin>

        {/* Bulk Expiry Modal */}
        <CustomAntdModal
          visible={isBulkExpiry}
          saveText={bulkExpiryLoading ? 'Saving' : 'Save'}
          okText={bulkExpiryLoading ? 'Saving' : 'Save'}
          cancelText="Cancel"
          onClose={() => { setBulkExpiryDate(''); setIsBulkExpiry(false); }}
          onCancel={() => { setIsBulkExpiry(false); setBulkExpiryDate(''); }}
          onSave={handleBulkExpiryDate}
          width={417}
          zIndex={10000}
        >
          <ModalWrapper className='bulk-expiry-modal'>
            <h6>Bulk Expiry</h6>
            <DatePicker
              style={{ width: '100%' }}
              getCalendarContainer={() => document.body}
              popupStyle={{ zIndex: 1000000 }}
              value={bulkExpiryDate ? moment(bulkExpiryDate) : null}
              format='YYYY-MM-DD'
              onChange={(date, dateString) => setBulkExpiryDate(dateString)}
            />
          </ModalWrapper>
        </CustomAntdModal>

        {/* Bulk Delete Confirm */}
        {isDeleteBulk && (
          <Modal
            open={isDeleteBulk}
            onClose={() => setIsDeleteBulk(false)}
            onHide={() => setIsDeleteBulk(false)}
            closeText="Cancel"
            saveText="Delete"
            header="Delete Confirmation"
            className='delete-confirmation-modal'
            closeButton
            onSave={handleBulkDeleteItems}
            buttonDisabled={bulkDeletingOrderItems}
          >
            <ModalWrapper>
              <div className='delete-modal-wrapper'>
                <img src={WarningIcon} alt='WarningIcon' />
                <Typography fontSize={24} component="h3" marginTop={3}>Warning</Typography>
                <p>Are you sure you want to delete the selected items?</p>
              </div>
            </ModalWrapper>
          </Modal>
        )}

        {/* Single Delete Confirm */}
        {isDelete && (
          <Modal
            open={isDelete}
            onClose={() => { setIsDelete(false); setPendingItemToDelete(null); }}
            onHide={() => { setIsDelete(false); setPendingItemToDelete(null); }}
            closeText="Cancel"
            saveText="Confirm"
            header="Delete Confirmation"
            className='delete-confirmation-modal'
            closeButton
            onSave={handleDeleteOrderItem}
            buttonDisabled={deletingOrderItem}
          >
            <ModalWrapper>
              <div className='delete-modal-wrapper'>
                <img src={WarningIcon} alt='WarningIcon' />
                <Typography fontSize={24} component="h3" marginTop={3}>Warning</Typography>
                <p>Are you sure you want to delete <b>{pendingItemToDelete ? pendingItemToDelete.sku : orderItems?.[rowIndex]?.sku}</b>?</p>
              </div>
            </ModalWrapper>
          </Modal>
        )}

        {/* Close guard — unsaved deletions or additions would desync our DB from Amazon */}
        {showCloseWarning && (
          <Modal
            open={showCloseWarning}
            onClose={() => setShowCloseWarning(false)}
            onHide={() => setShowCloseWarning(false)}
            closeText="Stay"
            saveText="Discard & Close"
            header="Unsaved Changes"
            className='delete-confirmation-modal'
            closeButton
            onSave={() => {
              setShowCloseWarning(false);
              onClose();
            }}
          >
            <ModalWrapper>
              <div className='delete-modal-wrapper'>
                <img src={WarningIcon} alt='WarningIcon' />
                <Typography fontSize={24} component="h3" marginTop={3}>Warning</Typography>
                <p>You have unsaved changes. Closing without confirming will leave the Amazon inbound plan out of sync. Discard changes?</p>
              </div>
            </ModalWrapper>
          </Modal>
        )}

        {/* Add SKU sub-drawer */}
        {addSku && (
          <AddSkuDrawer
            addSku={addSku}
            setAddSku={setAddSku}
            workOrderId={workOrderId}
            onAdd={(items) => {
              const invalidItems = items.filter(item => {
                const whStock = Number(item.warehouse_stock || 0);
                const shipQty = Number(item.ship_quantity || 0);
                return shipQty > whStock;
              });

              if (invalidItems.length > 0) {
                notification.warning({
                  message: 'Invalid Quantity',
                  description: `${invalidItems.length} item(s) exceed available warehouse stock and were not added.`,
                  top: 60
                });
              }

              const validItems = items.filter(item => {
                const whStock = Number(item.warehouse_stock || 0);
                const shipQty = Number(item.ship_quantity || 0);
                return shipQty <= whStock;
              });

              if (validItems.length > 0) {
                setPendingOrderItems(prev => [...prev, ...validItems]);
              }
            }}
          />
        )}

        {/* Print FNSKU Labels Modal */}
        {showPrintModal && (
          <Modal
            open={showPrintModal}
            onClose={() => { setShowPrintModal(false); setSelectedItemForPrint(null); }}
            onHide={() => { setShowPrintModal(false); setSelectedItemForPrint(null); }}
            closeText="Cancel"
            saveText="Print"
            header="Print FNSKU Labels"
            className='delete-confirmation-modal'
            closeButton
            onSave={handlePrintLabels}
            buttonDisabled={syncingSkuFullInfo}
          >
            <Spin spinning={syncingSkuFullInfo} tip="Syncing with Amazon...">
              <ModalWrapper>
                <Box display="flex" flexDirection="column" gap={2} padding={2}>
                  <Typography variant="body1">
                    Enter number of units to print for <b>{selectedItemForPrint?.sku}</b>
                  </Typography>
                  <Input
                    type="number"
                    placeholder="Number of units"
                    value={printQty}
                    onChange={(e) => setPrintQty(e.target.value)}
                    min={1}
                  />
                </Box>
              </ModalWrapper>
            </Spin>
          </Modal>
        )}
      </AddSkuDrawerWrapper>
    </Drawer>
  );
};

export default AddSkuToPlanDrawer;
